import React, { FC } from "react";
import { IScheduleCalendarMeeting, setClass, weekDaysShortUncap } from "../../../utils";
import { format } from "date-fns";
import { Meeting } from "./Meeting";
import '../../../styles/components/calendar/schedule/day.scss';

interface DayProps {
  date: Date;
  meetings: IScheduleCalendarMeeting[];
  isToday: boolean;
  onOpenMeeting: (id: number, calendarId: number, start?: Date, end?: Date) => void;
}

export const Day: FC<DayProps> = ({ date, meetings, isToday, onOpenMeeting }) => {
  const day = date.getDay();
  const weekDay = day === 0 ? weekDaysShortUncap[6] : weekDaysShortUncap[day - 1];

  return (
    <>
      <div className="mini-calendar-day">
        <div className="date">
          <span className="week-day">{weekDay}</span>
          <span className={setClass("date-number", isToday && 'today')}>{format(date, "dd")}</span>
        </div>
        <div className="meetings-list">
          {meetings?.map((meeting) => (
            <Meeting 
              key={meeting.id + +meeting.startTime} 
              meeting={meeting} 
              onOpenMeeting={onOpenMeeting}
            />
          ))}
        </div>
      </div>
    </>
  )
}
